var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DetailsItem',{staticClass:"details-permission"},[_c('div',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.name)+" ")]),_c('div',{staticClass:"description"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }